/**
 * buildProfileSubject — map a selected family/client profile to the ChitraGupt
 * session `subject` shape consumed by SessionModeController / SessionPlansModal:
 *   { kind:'profile', profile_id, name, dob, tob, pob, lat, lon, gender }.
 *
 * `profile_id` is the load-bearing field: it is what SessionPlansModal turns
 * into `client_profile_id` on POST /api/session/pre_reading, which the backend
 * uses to swap the chart to the member (backend/routes/session.py). Without it,
 * the pre-reading AND the paid chat run on the account owner's chart — the bug
 * this fix closes.
 *
 * Returns null for a falsy profile (or one missing profile_id) so callers can
 * write `subject={buildProfileSubject(activeFamilyProfile)}` and get null — the
 * unchanged owner flow — when no member is selected.
 */
export const buildProfileSubject = (profile) => {
  if (!profile || !profile.profile_id) return null;
  return {
    kind: 'profile',
    profile_id: profile.profile_id,
    name: profile.name,
    dob: profile.dob,
    tob: profile.tob,
    pob: profile.pob,
    lat: profile.lat,
    lon: profile.lon,
    gender: profile.gender,
  };
};
